import { apiFetch } from "#lib/api";

export async function fetchHasPendingDMs() {
  const path = `/has_pending_dms`;
  const result = await apiFetch<boolean>(path, { method: "GET" });

  return result;
}
